export { default as UploadAvatar } from './UploadAvatar';
export { default as UploadMultiFile } from './UploadMultiFile';
export { default as UploadSingleFile } from './UploadSingleFile';
export { default as UploadSingleFileAdd } from './UploadSingleFileAdd';
export { default as UploadSingleFileCover } from './UploadSingleFileCover';
export { default as UploadMultiAudioFile } from './UploadMultiAudioFile';
export { default as UploadMultiVideoFile } from './UploadMultiVideoFile';
export { default as UploadWithoutDefaultImage } from './UploadWithoutDefaultImage';
export { default as UploadAvatarTeam } from './UploadAvtarTeam';
export { default as UploadProjectMultiVideo } from './UploadProjectMultiVideo';
export { default as UploadAvatarProfile } from './UploadAvatarProfile';
